// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"pending-wwc__wrapper--1gYqB","message":"pending-wwc__message--36p2e"};